import { memo, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useState, MouseEvent, Fragment } from 'react';
import Menu from '@mui/material/Menu';
import { Button, CircularProgress, Grid, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useAppSelector } from "core/store/reduxStore";
import { BadgeCount, DesktopToolBar, FiltersAppliedBadge, TabletMobileToolBar } from "./alerts.styled";
import { 
  ExportBtn, 
  FilterTitle, 
  AlertsToolBarGrid, 
  AlertsToolbarLeftGrid, 
  AlertsToolbarRightGrid, 
  SearchAndStatusBarGrid,
  ExportButton,
  FilterButton
} from "./alerts.styled";

import DateRangePicker from "core/components/global/dateRangePicker/dateRangePicker";
import CasesFilterIcon from "assets/CasesFilterIcon";

import CasesExportIcon from "assets/CasesExportIcon";
import AdvanceSearch from "core/components/global/advanceSearch/advanceSearch";
import { CustomButtonContainer } from "core/components/global/buttons/button/customButton.styled";
import { Filters2 } from "core/components/global/homeToolbar/homeToolbar.styles";
import { getAlertFilters } from "modules/ac2/services/alertService";
import CustomSort from "core/components/global/customSort/customSort";
import { useLocation } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { useAppTheme } from "core/contexts/theme/theme";
import { getOCSFSeverityNameFromNumber } from "core/utils/common";
import { IRowProps } from "core/components/global/tables/datagrid/dataGrid.type";

interface FiltersProps {
  filterData: any;
  setIsFilterModalOpen: (boolean) => void;
  deleteFilter: (arg1: string, arg2: string) => void;
  clearSearch: () => void;
  setFilterData: any;
  rowData: IRowProps[];
}

function ActiveFilters({filterData, setIsFilterModalOpen, deleteFilter, clearSearch, setFilterData}: FiltersProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
  const { t } = useTranslation();
  
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div>
        <Menu
          id="active-filter-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          sx={{padding: "0"}}
        >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell></TableCell>
                  <TableCell align="left" variant="head">Column</TableCell>
                  <TableCell align="left" variant="head">Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {Object.entries(filterData["filterTerms"]).map(([category, categoryValues], index) => {
                    if (typeof categoryValues === 'string') {
                      // If 'value' is a string, split it and generate TableRow elements
                      return (
                        <Fragment key={`filter-item-${category}`}>
                          {categoryValues.split(',').map((value, valueIndex) => (
                            <TableRow key={`${category}-${valueIndex}`}>
                              <TableCell component="th" scope="row">
                                <CloseIcon onClick={() => deleteFilter(category, value)}/>
                              </TableCell>
                              <TableCell align="left">{category.slice(7, -1)}</TableCell>
                              <TableCell align="left">{value.trim()}</TableCell>
                            </TableRow>
                          ))}
                        </Fragment>
                      );
                    } else {
                      // Handle other types of 'value' here
                      return null; // or some other fallback
                    }
                  })}
                  {
                    filterData["searchTerm"] !== "" && <>
                      <TableRow key={`search-item`}>
                        <TableCell component="th" scope="row">
                          <CloseIcon onClick={() => clearSearch()}/>
                        </TableCell>
                        <TableCell align="left">search</TableCell>
                        <TableCell align="left">{filterData["searchTerm"]}</TableCell>
                      </TableRow>
                    </>
                  }
                </>
              </TableBody>
            </Table>
        </Menu>
      </div>
    </>
  );
}

function CategoryAlertsToolbar({rowData, headCells, setFilterData, setSearchValue, isFilterModalOpen, setIsFilterModalOpen, setPage, handleExportButton, filterData, deleteFilter, clearSearch, framework,descriptions, selectedDescription, selectedSectionTitle, onFilterCreated}: any) {
  const { t } = useTranslation();
  const isExportLoading = useAppSelector((state) => state.alerts.isExportLoading);
  const headerState = useAppSelector((state) => state.header);
  const location = useLocation();
  const theme = useTheme();
  
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClickListItem = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  console.log("filterData", filterData);
  console.log("Filter Terms:", filterData?.filterTerms);

  


  

  useEffect(() => {
    setIsFilterModalOpen(headerState.openAllFilters);
    
  }, [headerState.openAllFilters]);

  const nodeRef = useRef(null);
  const { apptheme } = useAppTheme();

  const isDarkTheme = apptheme?.name === "dark-theme";

  // Button styles now implemented directly in JSX with MUI's sx prop
 
  
  return (
    <>
      <div className="flex flex-row">
        <span className={`pe-2 pl-8 pt-4 d-flex ${isDarkTheme ? "text-white" : "text-black"}`}>
          Filters Applied :
        </span>

        <div className="d-flex flex-wrap gap-2 mt-[1.3rem]">
          {/* Conditionally show framework/section combined chip */}
          
          {/* Render other filters */}
          {Object.entries(filterData?.filterTerms || {}).map(([key, value]) => {
            console.log("Filter key:", key, "value:", value, "typeof value:", typeof value);
            // Skip rendering framework and section since they're already shown above
            if (
              value === undefined || 
              value === null
            ) return null;

            return (
              <div
                key={key}
                className={`flex items-center ${isDarkTheme ? "bg-[#2B313A] text-white" : "bg-purple-200 text-black"}  rounded-md px-3 py-1 h-[1.5rem]1`}
              >
                <CloseIcon
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteFilter(key, value);
                  }}
                  sx={{ fontSize: "1.1rem", cursor: "pointer" }}
                />
                <button className="pe-2 pl-[10px]">
                  {key.toLowerCase().includes("severity") && !isNaN(Number(value))
                    ? getOCSFSeverityNameFromNumber(t, Number(value)).toUpperCase()
                    : typeof value === "string"
                      ? value.toUpperCase()
                      : ""}
                </button>
              </div>
            );
          })}
        </div>

      </div>

      <DesktopToolBar className="d-flex flex-row mx-3">
        <SearchAndStatusBarGrid container>
          <Grid item xs className="d-flex flex-row">
            <AdvanceSearch filterByApi={true} rowData={rowData} setFilteredData={setSearchValue}/>
            <AlertsToolBarGrid container className="analystDash-cases-toolbar">
              <AlertsToolbarLeftGrid item xs>

              </AlertsToolbarLeftGrid>
              <AlertsToolbarRightGrid item xs>
                <CustomSort 
                  table_headers={headCells} 
                  setFilterData={setFilterData}
                  isFilterModalOpen={isFilterModalOpen || false}
                  setIsFilterModalOpen={setIsFilterModalOpen}
                  setPage={setPage}
                  getFiltersFunction={getAlertFilters}
                  framework={framework}
                  descriptions={descriptions}
                  selectedDescription={selectedDescription}
                  selectedSectionTitle={selectedSectionTitle}
                  onFilterCreated={onFilterCreated}
                />

                <FilterButton 
                  onClick={(Alert) => setIsFilterModalOpen(true)}
                >
                  <FilterTitle className="pe-2">{t("Filters")}</FilterTitle>
                  <CasesFilterIcon />
                </FilterButton>

                <span className="mx-1"></span>
                
                <ExportButton 
                  onClick={handleExportButton}
                >
                  <FilterTitle className="pe-2">{t("Export")}</FilterTitle>
                  <CasesExportIcon />
                  {isExportLoading && <CircularProgress size="1rem" sx={{color: "white"}} />}
                </ExportButton>
              </AlertsToolbarRightGrid>
            </AlertsToolBarGrid>
          </Grid>
        </SearchAndStatusBarGrid>
      </DesktopToolBar>
      

      <TabletMobileToolBar>
        <div className={headerState.openSearch ? 'component-visible' : 'component-hidden'}>
          <AdvanceSearch filterByApi={true} rowData={rowData} setFilteredData={setSearchValue}/>
        </div>
      </TabletMobileToolBar>
    </>
  );
}

export default memo(CategoryAlertsToolbar);